var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoneBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15743_43017)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1381 4.41792C13.3984 4.67827 13.3984 5.10038 13.1381 5.36073L7.36029 11.1385C7.09994 11.3989 6.67783 11.3989 6.41748 11.1385L3.52859 8.24962C3.26824 7.98927 3.26824 7.56716 3.52859 7.30681C3.78894 7.04646 4.21105 7.04646 4.4714 7.30681L6.88888 9.72429L12.1953 4.41792C12.4556 4.15757 12.8777 4.15757 13.1381 4.41792Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15743_43017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoneBlue);
export default __webpack_public_path__ + "static/media/iconDoneBlue.aace547e405872abf4524412dd50fef8.svg";
export { ForwardRef as ReactComponent };